
import {of as observableOf,  Observable } from 'rxjs';

import {catchError} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { IContactExports, IInvitationExports } from '@shared/services/api/legacy/reports-service/report-model';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/legacy/response';
import { IExportSurveyQuestions, IExportSurveyQuestionsForEvent, ISurveyQuestionsDetailsExports, ISurveyQuestionsExports } from '../survey-service/survey-model';
import { IExportContacts, IExportInvitees } from '@routes/reports/v1/models/report-model';

@Injectable()
export class ReportsService {
    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.api.baseUrl}${environment.api.prefix}${ReportsService.ENDPOINT}`; }
    private static readonly ENDPOINT = '/reports';

    public exportInvitees(model: IExportInvitees): Observable<SuccessResponse<IInvitationExports> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<IInvitationExports>>(ReportsService.URL + '/export/invitations', model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public exportContacts(model: IExportContacts): Observable<SuccessResponse<IContactExports> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<IContactExports>>(ReportsService.URL + '/export/contacts', model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public exportSurveyQuestionsStatistic(model: IExportSurveyQuestions): Observable<SuccessResponse<ISurveyQuestionsExports> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<ISurveyQuestionsExports>>(ReportsService.URL + '/export/survey', model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public exportSurveyQuestionsStatisticForEvent(surveyPageId: string, model: IExportSurveyQuestionsForEvent): Observable<SuccessResponse<ISurveyQuestionsExports> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<ISurveyQuestionsExports>>(ReportsService.URL + '/export/survey/' + surveyPageId, model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public exportSurveyQuestionsDetailStatisticForEvent(surveyPageId: string, model: IExportSurveyQuestionsForEvent): Observable<SuccessResponse<ISurveyQuestionsDetailsExports> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<ISurveyQuestionsDetailsExports>>(ReportsService.URL + '/export/survey/detailed/' + surveyPageId, model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }
}
